import React from 'react';
import { CompassIcon, SearchIcon, PenToolIcon, PaletteIcon, LayersIcon, BookOpenIcon, FolderOpenIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
const features = [{
  icon: CompassIcon,
  text: 'Clear brand & creative direction'
}, {
  icon: SearchIcon,
  text: 'Foundational brand deep dive'
}, {
  icon: PenToolIcon,
  text: 'Logo concepts refined to one confident mark'
}, {
  icon: PaletteIcon,
  text: 'Colour palette & typography direction'
}, {
  icon: LayersIcon,
  text: 'Core brand assets (final logo, social media templates, website hero direction, email newsletter template, email signature, LinkedIn assets)'
}, {
  icon: BookOpenIcon,
  text: 'Brand guidelines'
}, {
  icon: FolderOpenIcon,
  text: 'Organised files (web, digital, print)'
}];
export function WhatsIncluded() {
  return <section id="included" className="py-20 md:py-28 px-4 md:px-6 bg-surface border-b border-white/[0.06]" data-id="element-339">
      <div className="max-w-7xl mx-auto" data-id="element-340">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16" data-id="element-341">
          <div className="lg:col-span-5" data-id="element-342">
            <ScrollReveal data-id="element-343">
              <span className="text-accent font-bold tracking-[0.2em] text-xs md:text-sm uppercase block mb-4 md:mb-6" data-id="element-344">
                Deliverables
              </span>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-6 md:mb-8 tracking-tight uppercase leading-[0.9]" data-id="element-345">
                What's
                <br data-id="element-346" />
                included
              </h2>

              <div className="bg-surface-elevated border border-white/[0.06] text-white p-6 md:p-8 relative overflow-hidden" data-id="element-347">
                <h3 className="text-lg md:text-xl font-bold leading-tight relative z-10 mb-4" data-id="element-348">
                  4 week brand sprint for a clear, usable brand and logo.
                </h3>
                <p className="text-zinc-400 text-sm md:text-base leading-relaxed relative z-10" data-id="element-349">
                  Everything you need to launch with confidence, delivered in a
                  streamlined process.
                </p>
              </div>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-7" data-id="element-350">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/[0.06] border border-white/[0.06]" data-id="element-351">
              {features.map((feature, index) => <ScrollReveal key={index} delay={index * 0.08} data-id="element-352">
                  <div className="flex items-start p-5 md:p-6 bg-surface hover:bg-white/[0.02] transition-colors h-full" data-id="element-353">
                    <div className="mr-4 flex-shrink-0 mt-0.5" data-id="element-354">
                      <feature.icon className="w-5 h-5 text-accent" data-id="element-355" />
                    </div>
                    <span className="text-white text-sm md:text-base font-medium leading-relaxed" data-id="element-356">
                      {feature.text}
                    </span>
                  </div>
                </ScrollReveal>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}